/* PUSHAS 2026 — front-end enhancements. Loaded from layout/theme.liquid (defer) on every page.
   Site-wide: scroll reveals (section headers, product cards), header search placeholder, cart reassurance line.
   Product pages:
   1. Size grid: replaces the single "Size" dropdown with a grid of size chips showing the per-size price
      (PUSHAS is a marketplace, so every size has its own price). Keeps the theme's <select> in the DOM
      and drives it, so price / URL / add-to-cart keep working exactly as before.
   2. Trust rows: groups the icon rows (Authenticity Guarantee, Fastest Sizes) into a two-up band.
   3. Meta grid: turns "SKU: x / Colourway: y / Condition: z / Release Date: d" rows into a tidy 2-column grid. */
(function () {
  'use strict';
  if (!document.body) return;
  var isPDP = document.body.classList.contains('template-product');
  var isCart = document.body.classList.contains('template-cart');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Site-wide: scroll reveal ---------- */
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = '.halo-block-header, .sections-product-block .products-flex .product, .halo-recommendations-block .products-flex .product, .collection-product-grid .product, .productGrid .product, .products-grid .product, .newsletter-section .section-content, .policies-block .halo-row > *, .brand-slider .brands-block--wrapper';
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    var vh = window.innerHeight;
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) return; // above the fold: leave untouched, never delay the first paint
      var i = 0, sib = el;
      while ((sib = sib.previousElementSibling) && i < 8) i++;
      el.classList.add('p26-reveal');
      el.style.setProperty('--d', (i * 60) + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Site-wide: header search placeholder ---------- */
  function searchHint() {
    var inp = document.querySelector('.header__search-input .search__input');
    if (inp && /^search$/i.test(inp.placeholder || '')) inp.placeholder = 'Search brands, models, SKUs';
  }

  /* ---------- Cart: reassurance under the checkout button ---------- */
  function cartTrust() {
    if (!isCart) return;
    var actions = document.querySelector('.cart-actions .action-group');
    if (!actions || actions.querySelector('.p26-cart-trust')) return;
    var p = document.createElement('p'); p.className = 'p26-cart-trust';
    p.innerHTML = '<b>Authenticated by hand</b> before dispatch · <b>Secure checkout</b> · Afterpay &amp; Shop Pay available';
    actions.appendChild(p);
  }

  function globalInit() {
    try { reveal(); } catch (e) {}
    try { searchHint(); } catch (e) {}
    try { cartTrust(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', globalInit); else globalInit();

  if (!isPDP) return;

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    var v = cents / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    try {
      var loc = cur === 'AUD' ? 'en-AU' : cur === 'USD' ? 'en-US' : undefined;
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return '$' + (whole ? Math.round(v) : v.toFixed(2)); }
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var FAST = /\s*\(\s*fastest\s*\)\s*/i; // some variants are titled "US M 9 / W 10.5 (Fastest)" or "L (Fastest)"

  /* "US M 9 / W 10.5" -> <b>US M 9</b><small>W 10.5</small>; anything else -> <b>value</b> */
  function sizeLabel(value) {
    var wrap = document.createDocumentFragment();
    value = value.replace(FAST, ' ').trim();
    var parts = value.split('/');
    if (parts.length === 2 && parts[0].trim() && parts[1].trim()) {
      wrap.appendChild(el('b', null, parts[0].trim()));
      wrap.appendChild(el('small', null, parts[1].trim()));
    } else {
      wrap.appendChild(el('b', null, value.trim()));
    }
    return wrap;
  }

  function buildSizeGrid(vs) {
    if (!vs || vs.dataset.p26Done) return;
    var selects = vs.querySelectorAll('select.select__select');
    if (selects.length !== 1) return; // only single-option products (Size) get the grid
    var select = selects[0];
    var json = vs.querySelector('script[type="application/json"]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;
    if (variants.length === 1 && variants[0].title === 'Default Title') return;
    var wrap = vs.querySelector('.product-form__input--dropdown');
    if (!wrap) return;
    vs.dataset.p26Done = '1';

    var byValue = {};
    variants.forEach(function (v) { byValue[v.option1] = v; });

    var labelEl = wrap.querySelector('.form__label');
    var optionName = labelEl ? (labelEl.childNodes[0].textContent || 'Size').replace(':', '').trim() : 'Size';

    var box = el('div', 'p26-sizes');
    var head = el('div', 'p26-sizes-head');
    head.appendChild(el('span', 'p26-sizes-label', 'Select ' + optionName.toLowerCase()));
    var selectedOut = el('span', 'p26-sizes-current');
    head.appendChild(selectedOut);
    var isFootwear = variants.some(function (v) { return /\bUS\s*(M|W|Y)?\s*\d/i.test(v.option1 || ''); });
    if (isFootwear) {
      var guide = el('a', 'p26-sizes-guide', 'Size guide');
      guide.href = '/pages/size-chart-for-nike-new-balance-adidas-yeezy';
      head.appendChild(guide);
    }
    var grid = el('div', 'p26-sizes-grid');
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', optionName);

    Array.prototype.forEach.call(select.options, function (opt) {
      var v = byValue[opt.value];
      var b = el('button', 'p26-size');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.dataset.value = opt.value;
      var t = el('span', 'p26-size-t');
      t.appendChild(sizeLabel(opt.value));
      if (FAST.test(opt.value)) { b.classList.add('is-fast'); t.appendChild(el('em', 'p26-size-fast', 'Fastest')); }
      var p = el('span', 'p26-size-p');
      if (v && v.available) {
        p.textContent = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) b.classList.add('is-sale');
      } else {
        p.textContent = 'Sold out';
        b.classList.add('is-soldout');
      }
      b.appendChild(t);
      b.appendChild(p);
      b.addEventListener('click', function () {
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      grid.appendChild(b);
    });

    box.appendChild(head);
    box.appendChild(grid);
    wrap.parentNode.insertBefore(box, wrap.nextSibling);
    wrap.classList.add('p26-hidden');

    function sync() {
      var cur = select.value;
      var chips = grid.querySelectorAll('.p26-size');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i].dataset.value === cur;
        chips[i].classList.toggle('is-selected', on);
        chips[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      var v = byValue[cur];
      var curLabel = cur.replace(FAST, ' ').trim();
      selectedOut.textContent = v ? (v.available ? curLabel + ' · ' + money(v.price) : curLabel + ' · Sold out') : curLabel;
    }
    select.addEventListener('change', sync);
    sync();

    /* Default size: the theme preselects the first variant (US M 4), which people add by accident.
       If the URL names no variant, start on US M 10 Fastest (or the nearest available men's size, Fastest first). */
    if (isFootwear && !/[?&]variant=/.test(location.search)) {
      var best = null, bestScore = 999;
      Array.prototype.forEach.call(select.options, function (opt) {
        var m = /US\s*M\s*(\d+(?:\.5)?)/i.exec(opt.value);
        var v = byValue[opt.value];
        if (!m || !v || !v.available) return;
        // nearest to US M 10 wins; at the same size a Fastest variant beats a non-Fastest one
        var score = Math.abs(parseFloat(m[1]) - 10) * 10 + (FAST.test(opt.value) ? 0 : 1);
        if (score < bestScore) { bestScore = score; best = opt.value; }
      });
      if (best && best !== select.value) { select.value = best; select.dispatchEvent(new Event('change', { bubbles: true })); sync(); }
    }
  }

  function buildTrust() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.productView-product > .productView-moreItem'))
      .filter(function (it) { return it.querySelector('.product-customInformation:not(.disabled) .product-customInformation__icon svg'); });
    if (rows.length < 2 || rows[0].parentNode.querySelector('.p26-trust')) return;
    var band = el('div', 'p26-trust');
    rows[0].parentNode.insertBefore(band, rows[0]);
    rows.forEach(function (r) { band.appendChild(r); });
  }

  /* Third trust card: returns. Facts mirror the Returns Policy tab on the same page. */
  function buildReturnsCard() {
    var band = document.querySelector('.p26-trust');
    if (!band || band.querySelector('.p26-returns')) return;
    var item = el('div', 'productView-moreItem p26-returns');
    item.innerHTML = '<div class="product-customInformation text-left"><div class="product-customInformation__icon"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 3 3 9 9 9"/></svg></div><div class="product-customInformation__content"><div class="product__text title"><h2 class="title">Change of mind?</h2></div><div class="product__text des">Cancel free within 2 hours of ordering. After that, return within 90 days for store credit (10% handling charge).</div></div></div>';
    band.appendChild(item);
  }

  /* Sticky add-to-cart bar: appears once the buy box has scrolled out of view. */
  function buildSticky() {
    if (document.querySelector('.p26-sticky')) return;
    var buttons = document.querySelector('.productView-buttons');
    var submit = document.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.productView-title');
    if (!buttons || !submit || !titleEl || !('IntersectionObserver' in window)) return;
    var bar = el('div', 'p26-sticky');
    var inner = el('div', 'p26-sticky-inner');
    var img = document.querySelector('.productView-nav img, .productView-image img');
    if (img && (img.currentSrc || img.src)) { var im = el('img', 'p26-sticky-img'); im.src = img.currentSrc || img.src; im.alt = ''; inner.appendChild(im); }
    var txt = el('div', 'p26-sticky-txt');
    txt.appendChild(el('div', 'p26-sticky-title', titleEl.textContent.trim()));
    var v = el('div', 'p26-sticky-var'); txt.appendChild(v);
    inner.appendChild(txt);
    var select = document.querySelector('variant-selects select.select__select');
    if (select) {
      var sizesBtn = el('button', 'p26-sticky-sizes', 'Change size'); sizesBtn.type = 'button';
      sizesBtn.addEventListener('click', function () { var g = document.querySelector('.p26-sizes') || select; g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
      inner.appendChild(sizesBtn);
    }
    var btn = el('button', 'p26-sticky-btn'); btn.type = 'button';
    btn.addEventListener('click', function () { if (!submit.disabled) submit.click(); });
    inner.appendChild(btn);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    function refresh() {
      var priceEl = document.querySelector('.productView-price .price__sale .price-item--sale, .productView-price .price-item--regular, .productView-price .price-item');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var label = select ? select.value.replace(FAST, ' ').trim() : '';
      v.innerHTML = '';
      if (label) { var b = el('b', null, label); v.appendChild(b); v.appendChild(document.createTextNode(price ? ' · ' + price : '')); }
      else v.textContent = price;
      var out = submit.disabled || /sold out|unavailable/i.test(submit.textContent);
      btn.textContent = out ? 'Sold out' : 'Add to cart';
      btn.disabled = out;
    }
    refresh();
    if (select) select.addEventListener('change', function () { setTimeout(refresh, 400); setTimeout(refresh, 1200); });
    var mobileBar = document.querySelector('.halo-sticky-toolbar-mobile, .halo-toolbar-mobile, .toolbar-mobile');
    function offset() { if (mobileBar && mobileBar.offsetHeight && getComputedStyle(mobileBar).display !== 'none' && window.innerWidth < 1025) bar.style.bottom = mobileBar.offsetHeight + 'px'; else bar.style.bottom = '0px'; }
    offset(); window.addEventListener('resize', offset, { passive: true });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', passed);
      });
    }, { threshold: 0 });
    io.observe(buttons);
    var footer = document.querySelector('.wrapper-footer');
    if (footer) { new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) bar.classList.remove('is-on'); }); }, { threshold: 0.05 }).observe(footer); }
  }

  function buildMeta() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.productView-product > .productView-moreItem'))
      .filter(function (it) {
        var t = it.querySelector('.product-customInformation.disabled .product__text.title');
        return t && /^[A-Za-z ]{2,24}:/.test(t.textContent.trim());
      });
    if (rows.length < 2 || document.querySelector('.p26-meta')) return;
    var grid = el('div', 'p26-meta');
    var note = null;
    rows.forEach(function (it) {
      var t = it.querySelector('.product__text.title');
      var m = t.textContent.trim().match(/^([^:]+):\s*([\s\S]*)$/);
      it.classList.add('p26-hidden');
      if (!m) return;
      var val = m[2].replace(/\s+/g, ' ').trim();
      if (!val) return; // metafield empty -> drop the row entirely
      var item = el('div', 'p26-meta-item');
      item.appendChild(el('span', 'p26-meta-k', m[1].trim()));
      item.appendChild(el('span', 'p26-meta-v', val));
      grid.appendChild(item);
      var des = it.querySelector('.product__text.des');
      if (des && des.textContent.trim()) note = des.textContent.replace(/\s+/g, ' ').trim();
    });
    if (!grid.children.length) return;
    rows[0].parentNode.insertBefore(grid, rows[0]);
    if (note) grid.parentNode.insertBefore(el('p', 'p26-meta-note', note), grid.nextSibling);
  }

  function init() {
    try { buildSizeGrid(document.querySelector('variant-selects')); } catch (e) { /* never break the PDP */ }
    try { buildTrust(); } catch (e) {}
    try { buildReturnsCard(); } catch (e) {}
    try { buildMeta(); } catch (e) {}
    try { buildSticky(); } catch (e) {}
    document.documentElement.classList.add('p26-pdp-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* If the theme re-renders the buy box (variant change / section rendering), rebuild once it settles. */
  var host = document.querySelector('.productView-details');
  if (host && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var vs = document.querySelector('variant-selects');
        if (vs && !vs.dataset.p26Done) buildSizeGrid(vs);
        buildTrust(); buildReturnsCard(); buildMeta();
      }, 120);
    }).observe(host, { childList: true, subtree: true });
  }
})();